import { on } from "@ngrx/store";
import { ApplicationStore } from "../application.state";
import { CoreSettingsActions } from "./settings.actions";

// **************************************************************************
// SETTINGS REDUCER (array format for spreading in parent)
// Application-wide settings (not page-specific)
// **************************************************************************

const setAvailableLangs = on(CoreSettingsActions.setAvailableLangs, (state: ApplicationStore, { langs }) => ({
    ...state,
    settings: {
        ...state.settings,
        availableLangs: langs,
    },
}));

export const settingsReducer = [
    setAvailableLangs,
];
